import { createSelector } from 'reselect'

const getApiErrorState = state => state.apiError

export const getCatchedApiError = createSelector(
  getApiErrorState,
  apiError => apiError.catchedError
)
